import Parse from '../../parseConfig';

const STOCK_LISTING_EDITOR_ROLE_NAME = 'XXqHkoY1Rd-ListingEditor';

export async function getListingEditorRole() {
  const roleQuery = new Parse.Query(Parse.Role);
  roleQuery.equalTo('name', STOCK_LISTING_EDITOR_ROLE_NAME);

  return roleQuery.first();
}

export async function userHasListingEditorRole(user = Parse.User.current()) {
  if (!user) {
    return false;
  }

  const role = await getListingEditorRole();
  if (!role) {
    return false;
  }

  const usersQuery = role.getUsers().query();
  usersQuery.equalTo('objectId', user.id);

  const matchingUser = await usersQuery.first();
  return Boolean(matchingUser);
}

export { STOCK_LISTING_EDITOR_ROLE_NAME };
